module.exports = __webpack_public_path__ + "img/sankaku_78_red.3fe36b4c.png";